import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function RoomCard({ to, title, subtitle, description, icon: Icon, testid }) {
  return (
    <Link to={to} className="room-card group block p-6 md:p-7" data-testid={testid}>
      <span className="ornate-corner tl" /><span className="ornate-corner tr" />
      <span className="ornate-corner bl" /><span className="ornate-corner br" />
      <div className="flex items-center gap-3 mb-4">
        {Icon && (
          <div className="h-11 w-11 grid place-items-center rounded border" style={{borderColor:"rgba(212,175,55,0.35)", background:"rgba(0,0,0,0.25)"}}>
            <Icon className="h-5 w-5" style={{color:"var(--gold)"}} />
          </div>
        )}
        <div>
          <div className="page-eyebrow">{subtitle}</div>
          <div className="tavern-heading text-2xl gold-text">{title}</div>
        </div>
      </div>
      <p className="text-sm leading-relaxed" style={{color:"var(--muted)"}}>{description}</p>
      <div className="mt-5 flex items-center gap-2 text-sm" style={{color:"var(--orchid-light)"}}>
        <span className="tavern-script text-lg">enter the room</span>
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
